import { GetOpeningHoursDto, OpeningHourTypeEnum, WeekdayEnum } from '@kotipizzagroup/kotipizza-shops-api-admin-client';

export const openingHoursDefaults = {
  startTime: '10:00',
  endTime: '22:00',
  lunchEndTime: '14:00',
  closedTime: '00:00',
  deliveryEndTime: '21:30',
  eatInEndTime: '21:30',
  pickupEndTime: '21:50',
};

export type DailyHours = {
  startTime: string;
  endTime: string;
  isClosed: boolean;
};

export type WeeklyHours = Record<WeekdayEnum, DailyHours>;

export type HoursMap = Record<OpeningHourTypeEnum, WeeklyHours>;

export const createHoursMap = (hours?: GetOpeningHoursDto[]): HoursMap => {
  const restaurantHours = hours?.filter((h) => h.type === OpeningHourTypeEnum.Restaurant) || [];
  const ecomHours = hours?.filter((h) => h.type === OpeningHourTypeEnum.Ecommerce) || [];
  const deliveryHours = hours?.filter((h) => h.type === OpeningHourTypeEnum.Delivery) || [];
  const eatInHours = hours?.filter((h) => h.type === OpeningHourTypeEnum.EatIn) || [];
  const pickupHours = hours?.filter((h) => h.type === OpeningHourTypeEnum.Pickup) || [];
  const lunchHours = hours?.filter((h) => h.type === OpeningHourTypeEnum.Lunch) || [];

  const map = {
    [OpeningHourTypeEnum.Restaurant]: {
      [WeekdayEnum.Monday]: {
        startTime:
          restaurantHours.find((h) => h.weekday === WeekdayEnum.Monday)?.startTime || openingHoursDefaults.startTime,
        endTime: restaurantHours.find((h) => h.weekday === WeekdayEnum.Monday)?.endTime || openingHoursDefaults.endTime,
        isClosed: restaurantHours.find((h) => h.weekday === WeekdayEnum.Monday)?.isClosed || false,
      },
      [WeekdayEnum.Tuesday]: {
        startTime:
          restaurantHours.find((h) => h.weekday === WeekdayEnum.Tuesday)?.startTime || openingHoursDefaults.startTime,
        endTime:
          restaurantHours.find((h) => h.weekday === WeekdayEnum.Tuesday)?.endTime || openingHoursDefaults.endTime,
        isClosed: restaurantHours.find((h) => h.weekday === WeekdayEnum.Tuesday)?.isClosed || false,
      },
      [WeekdayEnum.Wednesday]: {
        startTime:
          restaurantHours.find((h) => h.weekday === WeekdayEnum.Wednesday)?.startTime || openingHoursDefaults.startTime,
        endTime:
          restaurantHours.find((h) => h.weekday === WeekdayEnum.Wednesday)?.endTime || openingHoursDefaults.endTime,
        isClosed: restaurantHours.find((h) => h.weekday === WeekdayEnum.Wednesday)?.isClosed || false,
      },
      [WeekdayEnum.Thursday]: {
        startTime:
          restaurantHours.find((h) => h.weekday === WeekdayEnum.Thursday)?.startTime || openingHoursDefaults.startTime,
        endTime:
          restaurantHours.find((h) => h.weekday === WeekdayEnum.Thursday)?.endTime || openingHoursDefaults.endTime,
        isClosed: restaurantHours.find((h) => h.weekday === WeekdayEnum.Thursday)?.isClosed || false,
      },
      [WeekdayEnum.Friday]: {
        startTime:
          restaurantHours.find((h) => h.weekday === WeekdayEnum.Friday)?.startTime || openingHoursDefaults.startTime,
        endTime: restaurantHours.find((h) => h.weekday === WeekdayEnum.Friday)?.endTime || openingHoursDefaults.endTime,
        isClosed: restaurantHours.find((h) => h.weekday === WeekdayEnum.Friday)?.isClosed || false,
      },
      [WeekdayEnum.Saturday]: {
        startTime:
          restaurantHours.find((h) => h.weekday === WeekdayEnum.Saturday)?.startTime || openingHoursDefaults.startTime,
        endTime:
          restaurantHours.find((h) => h.weekday === WeekdayEnum.Saturday)?.endTime || openingHoursDefaults.endTime,
        isClosed: restaurantHours.find((h) => h.weekday === WeekdayEnum.Saturday)?.isClosed || false,
      },
      [WeekdayEnum.Sunday]: {
        startTime:
          restaurantHours.find((h) => h.weekday === WeekdayEnum.Sunday)?.startTime || openingHoursDefaults.startTime,
        endTime: restaurantHours.find((h) => h.weekday === WeekdayEnum.Sunday)?.endTime || openingHoursDefaults.endTime,
        isClosed: restaurantHours.find((h) => h.weekday === WeekdayEnum.Sunday)?.isClosed || false,
      },
    },
    [OpeningHourTypeEnum.Ecommerce]: {
      [WeekdayEnum.Monday]: {
        startTime: ecomHours.find((h) => h.weekday === WeekdayEnum.Monday)?.startTime || openingHoursDefaults.startTime,
        endTime: ecomHours.find((h) => h.weekday === WeekdayEnum.Monday)?.endTime || openingHoursDefaults.endTime,
        isClosed: ecomHours.find((h) => h.weekday === WeekdayEnum.Monday)?.isClosed || false,
      },
      [WeekdayEnum.Tuesday]: {
        startTime:
          ecomHours.find((h) => h.weekday === WeekdayEnum.Tuesday)?.startTime || openingHoursDefaults.startTime,
        endTime: ecomHours.find((h) => h.weekday === WeekdayEnum.Tuesday)?.endTime || openingHoursDefaults.endTime,
        isClosed: ecomHours.find((h) => h.weekday === WeekdayEnum.Tuesday)?.isClosed || false,
      },
      [WeekdayEnum.Wednesday]: {
        startTime:
          ecomHours.find((h) => h.weekday === WeekdayEnum.Wednesday)?.startTime || openingHoursDefaults.startTime,
        endTime: ecomHours.find((h) => h.weekday === WeekdayEnum.Wednesday)?.endTime || openingHoursDefaults.endTime,
        isClosed: ecomHours.find((h) => h.weekday === WeekdayEnum.Wednesday)?.isClosed || false,
      },
      [WeekdayEnum.Thursday]: {
        startTime:
          ecomHours.find((h) => h.weekday === WeekdayEnum.Thursday)?.startTime || openingHoursDefaults.startTime,
        endTime: ecomHours.find((h) => h.weekday === WeekdayEnum.Thursday)?.endTime || openingHoursDefaults.endTime,
        isClosed: ecomHours.find((h) => h.weekday === WeekdayEnum.Thursday)?.isClosed || false,
      },
      [WeekdayEnum.Friday]: {
        startTime: ecomHours.find((h) => h.weekday === WeekdayEnum.Friday)?.startTime || openingHoursDefaults.startTime,
        endTime: ecomHours.find((h) => h.weekday === WeekdayEnum.Friday)?.endTime || openingHoursDefaults.endTime,
        isClosed: ecomHours.find((h) => h.weekday === WeekdayEnum.Friday)?.isClosed || false,
      },
      [WeekdayEnum.Saturday]: {
        startTime:
          ecomHours.find((h) => h.weekday === WeekdayEnum.Saturday)?.startTime || openingHoursDefaults.startTime,
        endTime: ecomHours.find((h) => h.weekday === WeekdayEnum.Saturday)?.endTime || openingHoursDefaults.endTime,
        isClosed: ecomHours.find((h) => h.weekday === WeekdayEnum.Saturday)?.isClosed || false,
      },
      [WeekdayEnum.Sunday]: {
        startTime: ecomHours.find((h) => h.weekday === WeekdayEnum.Sunday)?.startTime || openingHoursDefaults.startTime,
        endTime: ecomHours.find((h) => h.weekday === WeekdayEnum.Sunday)?.endTime || openingHoursDefaults.endTime,
        isClosed: ecomHours.find((h) => h.weekday === WeekdayEnum.Sunday)?.isClosed || false,
      },
    },
    [OpeningHourTypeEnum.Delivery]: {
      [WeekdayEnum.Monday]: {
        startTime:
          deliveryHours.find((h) => h.weekday === WeekdayEnum.Monday)?.startTime || openingHoursDefaults.startTime,
        endTime:
          deliveryHours.find((h) => h.weekday === WeekdayEnum.Monday)?.endTime || openingHoursDefaults.deliveryEndTime,
        isClosed: deliveryHours.find((h) => h.weekday === WeekdayEnum.Monday)?.isClosed || false,
      },
      [WeekdayEnum.Tuesday]: {
        startTime:
          deliveryHours.find((h) => h.weekday === WeekdayEnum.Tuesday)?.startTime || openingHoursDefaults.startTime,
        endTime:
          deliveryHours.find((h) => h.weekday === WeekdayEnum.Tuesday)?.endTime || openingHoursDefaults.deliveryEndTime,
        isClosed: deliveryHours.find((h) => h.weekday === WeekdayEnum.Tuesday)?.isClosed || false,
      },
      [WeekdayEnum.Wednesday]: {
        startTime:
          deliveryHours.find((h) => h.weekday === WeekdayEnum.Wednesday)?.startTime || openingHoursDefaults.startTime,
        endTime:
          deliveryHours.find((h) => h.weekday === WeekdayEnum.Wednesday)?.endTime ||
          openingHoursDefaults.deliveryEndTime,
        isClosed: deliveryHours.find((h) => h.weekday === WeekdayEnum.Wednesday)?.isClosed || false,
      },
      [WeekdayEnum.Thursday]: {
        startTime:
          deliveryHours.find((h) => h.weekday === WeekdayEnum.Thursday)?.startTime || openingHoursDefaults.startTime,
        endTime:
          deliveryHours.find((h) => h.weekday === WeekdayEnum.Thursday)?.endTime ||
          openingHoursDefaults.deliveryEndTime,
        isClosed: deliveryHours.find((h) => h.weekday === WeekdayEnum.Thursday)?.isClosed || false,
      },
      [WeekdayEnum.Friday]: {
        startTime:
          deliveryHours.find((h) => h.weekday === WeekdayEnum.Friday)?.startTime || openingHoursDefaults.startTime,
        endTime:
          deliveryHours.find((h) => h.weekday === WeekdayEnum.Friday)?.endTime || openingHoursDefaults.deliveryEndTime,
        isClosed: deliveryHours.find((h) => h.weekday === WeekdayEnum.Friday)?.isClosed || false,
      },
      [WeekdayEnum.Saturday]: {
        startTime:
          deliveryHours.find((h) => h.weekday === WeekdayEnum.Saturday)?.startTime || openingHoursDefaults.startTime,
        endTime:
          deliveryHours.find((h) => h.weekday === WeekdayEnum.Saturday)?.endTime ||
          openingHoursDefaults.deliveryEndTime,
        isClosed: deliveryHours.find((h) => h.weekday === WeekdayEnum.Saturday)?.isClosed || false,
      },
      [WeekdayEnum.Sunday]: {
        startTime:
          deliveryHours.find((h) => h.weekday === WeekdayEnum.Sunday)?.startTime || openingHoursDefaults.startTime,
        endTime:
          deliveryHours.find((h) => h.weekday === WeekdayEnum.Sunday)?.endTime || openingHoursDefaults.deliveryEndTime,
        isClosed: deliveryHours.find((h) => h.weekday === WeekdayEnum.Sunday)?.isClosed || false,
      },
    },
    [OpeningHourTypeEnum.EatIn]: {
      [WeekdayEnum.Monday]: {
        startTime:
          eatInHours.find((h) => h.weekday === WeekdayEnum.Monday)?.startTime || openingHoursDefaults.startTime,
        endTime: eatInHours.find((h) => h.weekday === WeekdayEnum.Monday)?.endTime || openingHoursDefaults.eatInEndTime,
        isClosed: eatInHours.find((h) => h.weekday === WeekdayEnum.Monday)?.isClosed || false,
      },
      [WeekdayEnum.Tuesday]: {
        startTime:
          eatInHours.find((h) => h.weekday === WeekdayEnum.Tuesday)?.startTime || openingHoursDefaults.startTime,
        endTime:
          eatInHours.find((h) => h.weekday === WeekdayEnum.Tuesday)?.endTime || openingHoursDefaults.eatInEndTime,
        isClosed: eatInHours.find((h) => h.weekday === WeekdayEnum.Tuesday)?.isClosed || false,
      },
      [WeekdayEnum.Wednesday]: {
        startTime:
          eatInHours.find((h) => h.weekday === WeekdayEnum.Wednesday)?.startTime || openingHoursDefaults.startTime,
        endTime:
          eatInHours.find((h) => h.weekday === WeekdayEnum.Wednesday)?.endTime || openingHoursDefaults.eatInEndTime,
        isClosed: eatInHours.find((h) => h.weekday === WeekdayEnum.Wednesday)?.isClosed || false,
      },
      [WeekdayEnum.Thursday]: {
        startTime:
          eatInHours.find((h) => h.weekday === WeekdayEnum.Thursday)?.startTime || openingHoursDefaults.startTime,
        endTime:
          eatInHours.find((h) => h.weekday === WeekdayEnum.Thursday)?.endTime || openingHoursDefaults.eatInEndTime,
        isClosed: eatInHours.find((h) => h.weekday === WeekdayEnum.Thursday)?.isClosed || false,
      },
      [WeekdayEnum.Friday]: {
        startTime:
          eatInHours.find((h) => h.weekday === WeekdayEnum.Friday)?.startTime || openingHoursDefaults.startTime,
        endTime: eatInHours.find((h) => h.weekday === WeekdayEnum.Friday)?.endTime || openingHoursDefaults.eatInEndTime,
        isClosed: eatInHours.find((h) => h.weekday === WeekdayEnum.Friday)?.isClosed || false,
      },
      [WeekdayEnum.Saturday]: {
        startTime:
          eatInHours.find((h) => h.weekday === WeekdayEnum.Saturday)?.startTime || openingHoursDefaults.startTime,
        endTime:
          eatInHours.find((h) => h.weekday === WeekdayEnum.Saturday)?.endTime || openingHoursDefaults.eatInEndTime,
        isClosed: eatInHours.find((h) => h.weekday === WeekdayEnum.Saturday)?.isClosed || false,
      },
      [WeekdayEnum.Sunday]: {
        startTime:
          eatInHours.find((h) => h.weekday === WeekdayEnum.Sunday)?.startTime || openingHoursDefaults.startTime,
        endTime: eatInHours.find((h) => h.weekday === WeekdayEnum.Sunday)?.endTime || openingHoursDefaults.eatInEndTime,
        isClosed: eatInHours.find((h) => h.weekday === WeekdayEnum.Sunday)?.isClosed || false,
      },
    },
    [OpeningHourTypeEnum.Pickup]: {
      [WeekdayEnum.Monday]: {
        startTime:
          pickupHours.find((h) => h.weekday === WeekdayEnum.Monday)?.startTime || openingHoursDefaults.startTime,
        endTime:
          pickupHours.find((h) => h.weekday === WeekdayEnum.Monday)?.endTime || openingHoursDefaults.pickupEndTime,
        isClosed: pickupHours.find((h) => h.weekday === WeekdayEnum.Monday)?.isClosed || false,
      },
      [WeekdayEnum.Tuesday]: {
        startTime:
          pickupHours.find((h) => h.weekday === WeekdayEnum.Tuesday)?.startTime || openingHoursDefaults.startTime,
        endTime:
          pickupHours.find((h) => h.weekday === WeekdayEnum.Tuesday)?.endTime || openingHoursDefaults.pickupEndTime,
        isClosed: pickupHours.find((h) => h.weekday === WeekdayEnum.Tuesday)?.isClosed || false,
      },
      [WeekdayEnum.Wednesday]: {
        startTime:
          pickupHours.find((h) => h.weekday === WeekdayEnum.Wednesday)?.startTime || openingHoursDefaults.startTime,
        endTime:
          pickupHours.find((h) => h.weekday === WeekdayEnum.Wednesday)?.endTime || openingHoursDefaults.pickupEndTime,
        isClosed: pickupHours.find((h) => h.weekday === WeekdayEnum.Wednesday)?.isClosed || false,
      },
      [WeekdayEnum.Thursday]: {
        startTime:
          pickupHours.find((h) => h.weekday === WeekdayEnum.Thursday)?.startTime || openingHoursDefaults.startTime,
        endTime:
          pickupHours.find((h) => h.weekday === WeekdayEnum.Thursday)?.endTime || openingHoursDefaults.pickupEndTime,
        isClosed: pickupHours.find((h) => h.weekday === WeekdayEnum.Thursday)?.isClosed || false,
      },
      [WeekdayEnum.Friday]: {
        startTime:
          pickupHours.find((h) => h.weekday === WeekdayEnum.Friday)?.startTime || openingHoursDefaults.startTime,
        endTime:
          pickupHours.find((h) => h.weekday === WeekdayEnum.Friday)?.endTime || openingHoursDefaults.pickupEndTime,
        isClosed: pickupHours.find((h) => h.weekday === WeekdayEnum.Friday)?.isClosed || false,
      },
      [WeekdayEnum.Saturday]: {
        startTime:
          pickupHours.find((h) => h.weekday === WeekdayEnum.Saturday)?.startTime || openingHoursDefaults.startTime,
        endTime:
          pickupHours.find((h) => h.weekday === WeekdayEnum.Saturday)?.endTime || openingHoursDefaults.pickupEndTime,
        isClosed: pickupHours.find((h) => h.weekday === WeekdayEnum.Saturday)?.isClosed || false,
      },
      [WeekdayEnum.Sunday]: {
        startTime:
          pickupHours.find((h) => h.weekday === WeekdayEnum.Sunday)?.startTime || openingHoursDefaults.startTime,
        endTime:
          pickupHours.find((h) => h.weekday === WeekdayEnum.Sunday)?.endTime || openingHoursDefaults.pickupEndTime,
        isClosed: pickupHours.find((h) => h.weekday === WeekdayEnum.Sunday)?.isClosed || false,
      },
    },
    [OpeningHourTypeEnum.Lunch]: {
      [WeekdayEnum.Monday]: {
        startTime:
          lunchHours.find((h) => h.weekday === WeekdayEnum.Monday)?.startTime || openingHoursDefaults.startTime,
        endTime: lunchHours.find((h) => h.weekday === WeekdayEnum.Monday)?.endTime || openingHoursDefaults.lunchEndTime,
        isClosed: lunchHours.find((h) => h.weekday === WeekdayEnum.Monday)?.isClosed || false,
      },
      [WeekdayEnum.Tuesday]: {
        startTime:
          lunchHours.find((h) => h.weekday === WeekdayEnum.Tuesday)?.startTime || openingHoursDefaults.startTime,
        endTime:
          lunchHours.find((h) => h.weekday === WeekdayEnum.Tuesday)?.endTime || openingHoursDefaults.lunchEndTime,
        isClosed: lunchHours.find((h) => h.weekday === WeekdayEnum.Tuesday)?.isClosed || false,
      },
      [WeekdayEnum.Wednesday]: {
        startTime:
          lunchHours.find((h) => h.weekday === WeekdayEnum.Wednesday)?.startTime || openingHoursDefaults.startTime,
        endTime:
          lunchHours.find((h) => h.weekday === WeekdayEnum.Wednesday)?.endTime || openingHoursDefaults.lunchEndTime,
        isClosed: lunchHours.find((h) => h.weekday === WeekdayEnum.Wednesday)?.isClosed || false,
      },
      [WeekdayEnum.Thursday]: {
        startTime:
          lunchHours.find((h) => h.weekday === WeekdayEnum.Thursday)?.startTime || openingHoursDefaults.startTime,
        endTime:
          lunchHours.find((h) => h.weekday === WeekdayEnum.Thursday)?.endTime || openingHoursDefaults.lunchEndTime,
        isClosed: lunchHours.find((h) => h.weekday === WeekdayEnum.Thursday)?.isClosed || false,
      },
      [WeekdayEnum.Friday]: {
        startTime:
          lunchHours.find((h) => h.weekday === WeekdayEnum.Friday)?.startTime || openingHoursDefaults.startTime,
        endTime: lunchHours.find((h) => h.weekday === WeekdayEnum.Friday)?.endTime || openingHoursDefaults.lunchEndTime,
        isClosed: lunchHours.find((h) => h.weekday === WeekdayEnum.Friday)?.isClosed || false,
      },
      [WeekdayEnum.Saturday]: {
        startTime:
          lunchHours.find((h) => h.weekday === WeekdayEnum.Saturday)?.startTime || openingHoursDefaults.closedTime,
        endTime: lunchHours.find((h) => h.weekday === WeekdayEnum.Saturday)?.endTime || openingHoursDefaults.closedTime,
        isClosed: lunchHours.find((h) => h.weekday === WeekdayEnum.Saturday)?.isClosed || true,
      },
      [WeekdayEnum.Sunday]: {
        startTime:
          lunchHours.find((h) => h.weekday === WeekdayEnum.Sunday)?.startTime || openingHoursDefaults.closedTime,
        endTime: lunchHours.find((h) => h.weekday === WeekdayEnum.Sunday)?.endTime || openingHoursDefaults.closedTime,
        isClosed: lunchHours.find((h) => h.weekday === WeekdayEnum.Sunday)?.isClosed || true,
      },
    },
  };
  return map;
};

export const hourTypeLabel = (type: OpeningHourTypeEnum): string => {
  switch (type) {
    case OpeningHourTypeEnum.Restaurant:
      return 'Ravintola';
    case OpeningHourTypeEnum.Ecommerce:
      return 'Verkkokauppa';
    case OpeningHourTypeEnum.Delivery:
      return 'Kuljetus';
    case OpeningHourTypeEnum.Pickup:
      return 'Nouto';
    case OpeningHourTypeEnum.EatIn:
      return 'Paikan päällä';
    case OpeningHourTypeEnum.Lunch:
      return 'Lounas';
    default:
      throw new Error('Missing value');
  }
};
